/* import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { User } from "../domain/user";
import { MessageService } from "primeng/api";
import { Configuration } from "../domain/configuration";
import { DynamicBackendConfigService } from "./dynamic-backend-config.service";

@Injectable()
export class UserService {
    uri =  "/api/users";

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private dynamicConfig: DynamicBackendConfigService
    ) {
        
    }

    get(): Promise<User[]> {
        let promise = this.http.get<User[]>(`${this.apiUrl}${this.uriPath}`).toPromise();
        //promise.then(data => console.log('Users: ' + JSON.stringify(data)));
        return promise;
    }

    getCurrentUserData(id): Promise<User> {
        let promise = this.http
            .get<User>(`${this.apiUrl}${this.uriPath}/GetCurrentUserData`)
            .toPromise();
        //promise.then(data => console.log('User : ' + JSON.stringify(data)));
        return promise;
    }

    getById(id): Promise<User> {
        let promise = this.http.get<User>(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        //promise.then(data => console.log('User : ' + JSON.stringify(data)));
        return promise;
    }

    post(obj: User) {
        let promise = this.http.post<User>(`${this.apiUrl}${this.uriPath}`, obj).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User created!",
                });
                obj.id = oa.id;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to create new user. Check console for errors.",
                    detail: error.status,
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    put(obj: User, id: string) {
        if (id == "new") {
            return this.post(obj);
        }

        let promise = this.http.put<User>(`${this.apiUrl}${this.uriPath}/${id}`, obj).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User updated!",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to update user. Check console for errors.",
                    detail: error.status,
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    delete(id: string) {
        let promise = this.http.delete(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User deleted!",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to delete user. Check console for errors.",
                    detail: error.status,
                });
                console.log(error.status, error.message);
            });
        return promise;
    }
}
 */

import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { User } from "../domain/user";
import { MessageService } from "primeng/api";
import { DynamicBackendConfigService } from "./dynamic-backend-config.service";
import { Observable } from "rxjs";
import { switchMap, tap, catchError } from "rxjs/operators";
import { AppConfigService } from "./app-config.service";
import { Utils } from "src/app/utilities/utils";

@Injectable()
export class UserService {
    private uriPath = "/api/users";
    uri = '';
    apiUrl="";

    constructor(
        private http: HttpClient,
        private messageService: MessageService,
        private dynamicConfig: DynamicBackendConfigService,
        private appConfigService: AppConfigService
    ) {
        this.apiUrl = this.appConfigService.apiUrl;
      /*  this.dynamicConfig.getApiUrl().subscribe(apiUrl => {
            this.uri = this.dynamicConfig.extractSecondURL(apiUrl ? `${apiUrl}${this.uriPath}` : this.uriPath);
          });
          */
    }

    
    get(): Promise<User[]> {
        let promise = this.http.get<User[]>(`${this.apiUrl}${this.uriPath}`).toPromise();
        //promise.then(data => console.log('Users: ' + JSON.stringify(data)));
        return promise;
    }

    getCurrentUserData(id): Promise<User> {
        let promise = this.http
            .get<User>(`${this.apiUrl}${this.uriPath}/GetCurrentUserData`)
            .toPromise();
        //promise.then(data => console.log('User : ' + JSON.stringify(data)));
        return promise;
    }

    getById(id): Promise<User> {
        let promise = this.http.get<User>(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        //promise.then(data => console.log('User : ' + JSON.stringify(data)));
        return promise;
    }

    post(obj: User) {
        let promise = this.http.post<User>(`${this.apiUrl}${this.uriPath}`, obj).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User created!",
                });
                obj.id = oa.id;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to create new user. Check console for errors.",
                    detail: Utils.extractSQLError(error.error),
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

    put(obj: User, id: string) {
        if (id == "new") {
            return this.post(obj);
        }

        let promise = this.http.put<User>(`${this.apiUrl}${this.uriPath}/${id}`, obj).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User updated!",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to update user. Check console for errors.",
                    detail: Utils.extractSQLError(error.error),
                });
               // console.log(error.status, error.message);
            });
        return promise;
    }

   
    delete(id: string) {
        let promise = this.http.delete(`${this.apiUrl}${this.uriPath}/${id}`).toPromise();
        promise
            .then((oa) => {
                this.messageService.add({
                    severity: "success",
                    summary: "User deleted!",
                });
            })
            .catch((error) => {
                this.messageService.add({
                    severity: "error",
                    summary:
                        "Failed to delete user. Check console for errors.",
                    detail: Utils.extractSQLError(error.error),
                });
                console.log(error.status, error.message);
            });
        return promise;
    }

/* 
    get(): Observable<User[]> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}`;
                return this.http.get<User[]>(url);
            })
        );
    }

    getCurrentUserData(): Observable<User> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/GetCurrentUserData`;
                return this.http.get<User>(url);
            })
        );
    }

    getById(id: string): Observable<User> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.get<User>(url);
            })
        );
    }

    post(obj: User): Observable<User> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}`;
                return this.http.post<User>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "User created!",
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to create new user. Check console for errors.",
                            detail: error.status,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    put(obj: User, id: string): Observable<User> {
        if (id === "new") {
            return this.post(obj);
        }

        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.put<User>(url, obj).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "User updated!",
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to update user. Check console for errors.",
                            detail: error.status,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    }

    delete(id: string): Observable<void> {
        return this.dynamicConfig.getApiUrl().pipe(
            switchMap(apiUrl => {
                const url = `${apiUrl}${this.apiUrl}${this.uriPath}/${id}`;
                return this.http.delete<void>(url).pipe(
                    tap(() => {
                        this.messageService.add({
                            severity: "success",
                            summary: "User deleted!",
                        });
                    }),
                    catchError(error => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Failed to delete user. Check console for errors.",
                            detail: error.status,
                        });
                        console.log(error.status, error.message);
                        throw error;
                    })
                );
            })
        );
    } */
}
